import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react";
import "./DatePickerFilter.css";
import { IoMdClose } from "react-icons/io";
import { DayPicker } from "react-day-picker";
import { BsCheckLg } from "react-icons/bs";
import "react-day-picker/dist/style.css";
import Icon from "../Icon/Icon";
import IconButton from "../kit/IconButton";
import calendarIcon from "../../assets/icons/calendar-icon.svg";
import { DateTime } from "luxon";

// "oct 8" style label for the picked date / range
const formatDay = (date) =>
  date.toLocaleDateString(undefined, { month: "short", day: "numeric" }).toLowerCase();

const DatePickerFilter = forwardRef(
  ({ currentDate, setCurrentDate, onCalendarIconClick }, ref) => {
    const [calendarOpen, setCalendarOpen] = useState(false);
    // const [isDefaultDate, setIsDefaultDate] = useState(false);

    // Debug: Log when calendarOpen state changes
    useEffect(() => {
      console.log('DatePickerFilter calendarOpen state changed:', calendarOpen);
    }, [calendarOpen]);

    // useEffect(() => {
    //   if (currentDate) {
    //     if (currentDate.start && currentDate.end) {
    //       if (
    //         currentDate?.start?.toLocaleDateString() ===
    //           DateTime.now().startOf("day").toJSDate().toLocaleDateString() &&
    //         currentDate?.end?.toLocaleDateString() ===
    //           DateTime.now()
    //             .startOf("day")
    //             .plus({ hours: 48 })
    //             .toJSDate()
    //             .toLocaleDateString()
    //       ) {
    //         setIsDefaultDate(true);
    //       } else {
    //         setIsDefaultDate(false);
    //       }
    //     }
    //   }
    // }, [currentDate]);

    useImperativeHandle(ref, () => ({
      calendarOpen: calendarOpen,
      openCalendar: () => {
        console.log('DatePickerFilter.openCalendar() called', { currentState: calendarOpen });
        setCalendarOpen(true);
        console.log('DatePickerFilter.openCalendar() - state set to true');
      },
      closeCalendar: () => {
        console.log('DatePickerFilter.closeCalendar() called');
        setCalendarOpen(false);
      },
      toggleCalendar: () => {
        console.log('DatePickerFilter.toggleCalendar() called', { currentState: calendarOpen, willBe: !calendarOpen });
        setCalendarOpen(!calendarOpen);
      },
    }));

    const handleSelect = (date) => {
      if (!date) {
        if (currentDate.start) {
          setCurrentDate({
            start: new Date(currentDate.start.setHours(0, 0, 0)),
            end: new Date(currentDate.start.setHours(23, 59, 59)),
          });
        }
      } else {
        if (!date.to) {
          setCurrentDate({
            start: new Date(date.from.setHours(0, 0, 0)),
            end: new Date(date.from.setHours(23, 59, 59)),
          });
        } else {
          setCurrentDate({
            start: new Date(date.from.setHours(0, 0, 0)),
            end: new Date(date.to.setHours(23, 59, 59)),
          });
        }
      }
    };

    const cancelFilter = () => {
      setCurrentDate(null);
    };

    const toggleCalendar = () => {
      setCalendarOpen(!calendarOpen);
    };

    const isDefaultDate =
      currentDate?.start?.toLocaleDateString() ===
        DateTime.now().startOf("day").toJSDate().toLocaleDateString() &&
      currentDate?.end?.toLocaleDateString() ===
        DateTime.now()
          .startOf("day")
          .plus({ hours: 48 })
          .toJSDate()
          .toLocaleDateString();

    return (
      <>
        <IconButton
          label="pick a date"
          aria-expanded={calendarOpen}
          className="shrink-0"
          onClick={() => {
            toggleCalendar();
            onCalendarIconClick && onCalendarIconClick();
          }}
          icon={
            <span className="flex w-[1.125rem] h-[1.125rem] md:w-[1.375rem] md:h-[1.375rem]">
              <Icon
                src={calendarIcon}
                alt=""
                imgClassName={
                  currentDate
                    ? "invert-[--inyc-invert-white]"
                    : "invert-[--inyc-lighten-white]"
                }
              />
            </span>
          }
        />
        <div className={`date-picker-filter-container ${calendarOpen ? "open" : ""}`}>
          <div
            className={`date-picker-calendar-container w-[90%] mx-auto ${
              calendarOpen ? "inyc-panel !p-0 shadow-kit-md open" : ""
            }`}
          >
            <div id="date-picker">
              <div className="date-picker-filter">
                {!isDefaultDate && currentDate?.start ? (
                  <span className="inyc-tag is-lg">
                    {formatDay(currentDate.start)}
                    {currentDate.end &&
                    currentDate.start.toLocaleDateString() !==
                      currentDate.end.toLocaleDateString()
                      ? ` – ${formatDay(currentDate.end)}`
                      : ""}
                    <IconButton
                      size="xs"
                      label="clear date"
                      icon={<IoMdClose />}
                      onClick={cancelFilter}
                    />
                  </span>
                ) : (
                  <span className="inyc-help is-sm">select a date or date range</span>
                )}
              </div>
              <DayPicker
                id="date-picker-calendar"
                showOutsideDays
                mode="range"
                selected={
                  isDefaultDate
                    ? null
                    : { from: currentDate?.start, to: currentDate?.end }
                }
                onSelect={handleSelect}
                footer={false}
                formatters={{
                  formatCaption: (month, { locale }) => {
                    return (
                      month
                        .toLocaleString(locale, { month: "long" })
                        .toLowerCase() +
                      " " +
                      month.toLocaleString(locale, { year: "numeric" })
                    );
                  },
                }}
              />
              <div className="date-picker-checkmark-row">
                <IconButton
                  label="done"
                  icon={<BsCheckLg />}
                  onClick={toggleCalendar}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default DatePickerFilter;
